var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_4236)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16602 1.33301C6.5342 1.33301 6.83268 1.63148 6.83268 1.99967V2.66685H7.49935C7.86754 2.66685 8.16602 2.96533 8.16602 3.33352C8.16602 3.70171 7.86754 4.00019 7.49935 4.00019H6.8087C6.7133 5.31957 6.33734 6.52568 5.75493 7.45752C5.73535 7.48883 5.71549 7.51992 5.69534 7.55075C6.3233 7.80938 7.10782 7.97855 7.98242 8.00002C8.3505 8.00905 8.64156 8.31476 8.63253 8.68284C8.62349 9.05092 8.31778 9.34198 7.9497 9.33295C6.75907 9.30372 5.6532 9.03913 4.7757 8.59541C4.22244 9.05078 3.56602 9.33301 2.83268 9.33301C2.46449 9.33301 2.16602 9.03453 2.16602 8.66634C2.16602 8.29815 2.46449 7.99967 2.83268 7.99967C3.09288 7.99967 3.36107 7.92704 3.62455 7.77696C3.14798 7.29408 2.83273 6.69431 2.83273 5.99981C2.83273 5.63162 3.13121 5.33315 3.4994 5.33315C3.86759 5.33315 4.16606 5.63162 4.16606 5.99981C4.16606 6.25365 4.28398 6.54644 4.56872 6.83743C4.58737 6.80911 4.60589 6.78024 4.62427 6.75083C5.0639 6.04745 5.37885 5.09147 5.47133 4.00019H2.83268C2.46449 4.00019 2.16602 3.70171 2.16602 3.33352C2.16602 2.96533 2.46449 2.66685 2.83268 2.66685H5.49935V1.99967C5.49935 1.63148 5.79783 1.33301 6.16602 1.33301ZM10.8327 6.66685C11.0961 6.66685 11.3349 6.82201 11.4419 7.06276L14.1085 13.0628C14.2581 13.3992 14.1065 13.7932 13.7701 13.9427C13.4336 14.0923 13.0397 13.9407 12.8901 13.6043L12.4733 12.6665H9.192L8.7752 13.6043C8.62567 13.9407 8.23169 14.0923 7.89524 13.9427C7.55878 13.7932 7.40725 13.3992 7.55679 13.0628L10.2235 7.06276C10.3305 6.82201 10.5692 6.66685 10.8327 6.66685ZM9.7846 11.3331H11.8807L10.8327 8.975L9.7846 11.3331Z",
    fill: "#4B4AD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_4236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.166016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.e3589cfcad6f6fdf99140216dedb5bc9.svg";
export { ForwardRef as ReactComponent };